module.exports = __webpack_public_path__ + "static/media/side-by-side.d63671c7.png";